document.addEventListener('DOMContentLoaded', () => {
    // Vérification de la connexion WebSocket sur la page d'accueil
    if (document.body.dataset.url === 'index') {
        const wsScheme = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        const wsUrl = `${wsScheme}//${window.location.host}/ws/connect/`;
        let socket: WebSocket | null = null;
        let heartbeatInterval: number | null = null;
        let reconnectTimeout: number | null = null;

        const connect = () => {
            console.log(`[WebSocket] Tentative de connexion à ${wsUrl}...`);

            try {
                socket = new WebSocket(wsUrl);

                socket.onopen = () => {
                    console.log('%c[WebSocket] Connecté avec succès au serveur Django Channels !', 'color: #00aa00; font-weight: bold;');

                    // Message initial de ping
                    socket?.send(JSON.stringify({ action: 'ping', page: 'accueil', horodatage: new Date().toISOString() }));

                    // Heartbeat toutes les 25s pour maintenir les proxies et pare-feu ouverts
                    if (heartbeatInterval) clearInterval(heartbeatInterval);
                    heartbeatInterval = window.setInterval(() => {
                        if (socket && socket.readyState === WebSocket.OPEN) {
                            socket.send(JSON.stringify({ action: 'heartbeat' }));
                        }
                    }, 25000);
                };

                socket.onmessage = (event) => {
                    try {
                        const data = JSON.parse(event.data);
                        console.log('[WebSocket] Données reçues du serveur :', data);
                    } catch {
                        console.log('[WebSocket] Message brut reçu :', event.data);
                    }
                };

                socket.onerror = (error) => {
                    console.warn('[WebSocket] Erreur de connexion ou instance Channels inactive :', error);
                };

                socket.onclose = (event) => {
                    if (heartbeatInterval) {
                        clearInterval(heartbeatInterval);
                        heartbeatInterval = null;
                    }

                    if (event.code === 4001) {
                        console.log('%c[WebSocket] Session expirée ou utilisateur déconnecté (code 4001). Arrêt.', 'color: #d9534f;');
                        return;
                    }

                    console.log(`[WebSocket] Connexion terminée (code: ${event.code}). Nouvelle tentative dans 3s...`);

                    // Reconnexion automatique après 3s si pas de fermeture volontaire ni refus d'authentification
                    if (event.code !== 1000 && event.code !== 4001) {
                        if (reconnectTimeout) clearTimeout(reconnectTimeout);
                        reconnectTimeout = window.setTimeout(connect, 3000);
                    }
                };
            } catch (e) {
                console.error('[WebSocket] Erreur d\'initialisation du WebSocket :', e);
            }
        };

        connect();

        window.addEventListener('beforeunload', () => {
            if (heartbeatInterval) clearInterval(heartbeatInterval);
            if (reconnectTimeout) clearTimeout(reconnectTimeout);
            if (socket) socket.close(1000, "Page navigation");
        });
    }
});
